import { render, staticRenderFns } from "./BillingRoles.vue?vue&type=template&id=67446de9&"
import script from "./BillingRoles.vue?vue&type=script&lang=js&"
export * from "./BillingRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports